// extracted by mini-css-extract-plugin
export var md = "_4k-4";
export var semantic = "_4k-5";
export var sm = "_4k-3";
export var text = "_4k-6";
export var toggleInput = "_4k-0";
export var toggleSwitch = "_4k-1";
export var xs = "_4k-2";